import { render, staticRenderFns } from "./Our_history.vue?vue&type=template&id=33a1f556&scoped=true"
import script from "./Our_history.vue?vue&type=script&lang=js"
export * from "./Our_history.vue?vue&type=script&lang=js"
import style0 from "./Our_history.vue?vue&type=style&index=0&id=33a1f556&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a1f556",
  null
  
)

export default component.exports